import * as React from 'react';
import styled, { css } from 'styled-components';
import { Input } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';

const Container = styled.fieldset`
  ${props => props.$width && css`
    flex-grow: 0;
    flex-basis: auto;
    width: ${props.$width};
  `}
`;

const TextBox = (props) => {
  const { valid, validationMessage, ...rest } = props;
  return (
    <Container $width={props.width} className={'k-form-fieldset'}>
      <Input
        {...rest}
        valid={valid}
        validationMessage={validationMessage}
        labelClassName='k-label'
      />
      {!valid && <Error>{validationMessage}</Error>}
    </Container>
  );
};

export default TextBox;